import React from 'react';
import PropTypes from 'prop-types';
import RadioButton from './RadioButton';

const RadiosWrapper = ({blockReasons, selectedReason, changeReason}) => {
    const OTHER = 'other';

    return (
        <ul>
            { blockReasons.map((reason) => {
                const reasonText = i18n.t(`seller_card.block_user.options.${reason}`);

                return (
                    <RadioButton key={reason}
                        selectedValue={selectedReason.reason}
                        reason={reason}
                        reasonText={reasonText}
                        onChange={() => changeReason(reason, reasonText)}/>
                );
            })}
            <RadioButton selectedValue={selectedReason.reason}
                reason={OTHER}
                reasonText={i18n.t(`seller_card.block_user.options.${OTHER}`)}
                onChange={() => changeReason(OTHER, '')}/>
            {
                selectedReason.reason === OTHER &&
                <textarea value={selectedReason.reasonText}
                    onChange={(e) => changeReason(OTHER, e.target.value)}/>
            }
        </ul>
    );
};

RadiosWrapper.propTypes = {
    blockReasons: PropTypes.array,
    selectedReason: PropTypes.object,
    changeReason: PropTypes.func
};

RadiosWrapper.defaultProps = {
    blockReasons: [],
    selectedReason: { reason: '', reasonText: ''}
};

export default RadiosWrapper;


// WEBPACK FOOTER //
// ./src/components/block_user/ModalWrapper/ModalBody/RadiosWrapper.js